import { render, staticRenderFns } from "./ProctoringStream.vue?vue&type=template&id=c5c1b1ae&"
import script from "./ProctoringStream.vue?vue&type=script&lang=js&"
export * from "./ProctoringStream.vue?vue&type=script&lang=js&"
import style0 from "./ProctoringStream.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports